.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  max-width: var(--form-max);
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: var(--space-2);
  padding: 0;
  color: var(--ink);
  font: var(--t-heading);
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}

.fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
